export default 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
